<template>
    <div :class="['report-result', $i18n.locale]">
        <div class="shape-title">
            <span>{{ $t('tun-xing-ping-gu') }}</span>
        </div>
        <div class="result-wrapper">
            <div class="result-box">
                <p class="tishi">{{ $t('yi-xia-shi-nin-de-tun-xing-lei-xing') }}</p>
                <div class="result-wrapper2" :style="contrast ? 'display:flex;justify-content: space-evenly;' : ''">
                    <tun-data-item
                        v-if="contrast && hiptype2 != hiptype"
                        :title="$t('li-shi')"
                        :hipType="hiptype2"
                        :hipGirth="contrast.hipGirth"
                    />
                    <tun-data-item
                        :isnew="!contrast ? true : false"
                        :title="hiptype2 == hiptype && contrast ? $t('ben-ci-li-shi') :$t('ben-ci')"
                        :hipType="hiptype"
                        :hipGirth="latest.hipGirth"
                        :conhipGirth="hiptype2 == hiptype && contrast ? contrast.hipGirth : 0"
                    />
                </div>
                <p
                    v-if="hiptype === 0 || hiptype2 === 0"
                    class="show"
                >{{ $t('fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du') }}</p>
                <p
                    v-if="hiptype === 1|| hiptype2 === 1"
                    class="show"
                >{{ $t('yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing') }}</p>
                <p
                    v-if="hiptype === 2|| hiptype2 === 2"
                    class="show"
                >{{ $t('li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man') }}</p>
                <p
                    v-if="hiptype === 3|| hiptype2 === 3"
                    class="show"
                >{{$t('dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing')}}</p>
                <p
                    v-if="hiptype === 4|| hiptype2 === 4"
                    class="show"
                >{{ $t('mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing') }}</p>
            </div>
        </div>
        <div class="shape-title">
            <span>{{ $t('qi-ta-tun-xing') }}</span>
        </div>
        <div class="result-wrapper">
            <div class="result-box">
                <div class="result-wrapper3" v-for="(item, index) in hiptype3" :key="index">
                    <img :src="require(`@/assets/images/tun/${item}A.svg`)" />
                    <div class="right">
                        <p class="title">
                            <img v-if="item === 4 || item === 1" src="@/assets/images/dianzan.png" class="dianzan" />
                            {{ item === 0 ? $t('fang-xing-tun') : item === 2 ? $t('li-xing-tun') :
                            item === 3 ? $t('dao-san-jiao-xing-tun') : item === 1 ? $t('yuan-xing-tun') : $t('mi-tao-tun')}}
                        </p>
                        <p class="tips">{{ showzi(item) }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="result-wrapper">
            <div class="result-box">
                <p class="hip-title">{{ $t('tun-xing-shuo-ming') }}</p>
                <p
                    class="hip-tips"
                >{{ $t('tun-xing-shi-zhi-ren-ti-hou-bei-bu-yu-da-tui-zhi-jian-de-bu-wei-suo-xing-cheng-de-qu-xian-he-xing-zhuang-tun-xing-ping-gu-ke-yi-bang-zhu-ren-men-geng-hao-di-shi-xian-xing-xiang-guan-li-he-jian-kang-guan-mai') }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import thermalImg4 from '@/assets/images/round_hipCircumference.png'
import TunDataItem from '@/components/common/TunDataItem.vue'

export default {
    components: {
        TunDataItem,
    },
    props: {
        hipdata: Object,
    },
    data() {
        return {
            modelInfo: JSON.parse(window.localStorage.getItem('modelInfo')),
            thermalImg4,
            isMoreTime: true,
            popupVisible: false,
            select: false,
            selectTime: '',
            lastSelectTime: '',
            timeList: [],
            scanId: '',
            tcScanId: '',
            // 对比最新数据的上一次
            defaultScanId: '',
            originDate: '', // 初始日期
            compared: false,
            pop: false,
            showzivis: false,
            txt: '',
            num: -1,
            isactive: -1,
            unit: '',
        }
    },
    computed: {
        contrast() {
            console.log(this.hipdata, '>>>>>>>>>')
            return this.hipdata.contrastHipGirth || null
        },
        latest() {
            return this.hipdata.latestHipGirth || null
        },
        hiptype() {
            return this.hipdata.latestHipGirth ? this.hipdata.latestHipGirth.hipType : ''
        },
        hiptype2() {
            return this.hipdata.contrastHipGirth ? this.hipdata.contrastHipGirth.hipType : ''
        },
        hiptype3() {
            const list = [0, 2, 3, 1, 4]
            return list.filter((item) => item !== this.hiptype && item !== this.hiptype2)
        },
    },
    mounted() {
        this.unit = window.localStorage.getItem('unit') || 'metric'
    },
    methods: {
        showzi(zi) {
            if (zi == 0) {
                return this.$t(
                    'fang-xing-tun-fang-xing-tun-shi-jue-gan-guan-shang-xia-yi-yang-kuan-tun-liang-ce-xian-tiao-jiao-zhi-mei-you-hu-du'
                )
            }
            if (zi == 1) {
                return this.$t(
                    'yuan-xing-tun-shi-jue-gan-guan-xiang-yi-ge-yuan-xing-tun-bu-zhi-fang-fen-bu-jun-yun-yuan-run-bao-man-shi-fei-chang-li-xiang-de-tun-xing'
                )
            }
            if (zi == 2) {
                return this.$t(
                    'li-xing-tun-shi-jue-gan-guan-shang-zhai-xia-kuan-xia-tun-ji-rou-zhi-fang-fen-bu-jiao-duo-xian-tiao-bu-gou-feng-man'
                )
            }
            if (zi == 3) {
                return this.$t('dao-san-jiao-xing-tun-shi-jue-gan-guan-shang-kuan-xia-zhai-cheng-dao-san-jiao-xing')
            }
            if (zi == 4) {
                return this.$t(
                    'mi-tao-tun-shi-jue-shang-xiang-yi-ge-mi-tao-xing-zhuang-tun-bu-xia-fang-feng-man-yao-bu-xian-xi-shi-fei-chang-li-xiang-de-tun-xing'
                )
            }
        },
    },
}
</script>

<style lang="less" scope>
.report-result {
    margin: 15px 15px 0 11px;
    font-family: PingFangSC, PingFang SC;

    .shape-title {
        width: 100px;
        height: 28px;
        margin-bottom: -2px;
        line-height: 26px;
        color: #222222;
        font-family: PingFangSC, PingFang SC;
        background: url(../../assets/images/waist/shape_over_en.png) center no-repeat;
        background-size: 100% 100%;
        text-align: center;

        span {
            letter-spacing: 0.2px;
            width: 98px;
            height: 14px;
            // margin-left: 5px;
            font-size: 14px;
        }
    }

    .result-wrapper {
        width: 353px;
        background: url(../../assets/images/waist/waistbg1.png) center no-repeat;
        background-size: 100% 100%;
        // border: white 1px solid;
        color: #8aa3be;
        .result-wrapper2 {
            width: 300px;
            // height: 410px;
            background-size: 100% 100%;
            // border: white 1px solid;
            margin: 0 auto;
            .show {
                font-weight: 400;
                font-size: 12px;
                color: #6f8399;
                line-height: 17px;
                text-align: left;
                font-style: normal;
                width: 300px;
            }
        }
    }

    .result-box {
        text-align: left;
        // padding: 10px 15px;
        padding: 10px 0;
        margin: 10px auto;
        width: 300px;
        margin-top: 0;
        // opacity: 0.2;
        .result-wrapper3 {
            width: 300px;
            // height:60px;
            display: flex;
            justify-content: space-between;
            margin-top: 10px;
            align-items: center;
            img {
                width: 55px;
                height: 48px;
            }
            .right {
                width: 220px;
                margin-left: 10px;
                .title {
                    font-weight: 400;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 20px;
                    text-align: left;
                    font-style: normal;
                }
                .tips {
                    font-weight: 400;
                    font-size: 12px;
                    color: #8aa3be;
                    line-height: 17px;
                    text-align: left;
                    font-style: normal;
                }
            }
        }
        .hip-title {
            border-left: 1px solid #00e3c9;
            padding-left: 10px;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin: 10px 0;
        }
        .hip-tips {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #8aa3be;
            line-height: 20px;
            text-align: left;
            font-style: normal;
        }
    }
    .tishi {
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        font-style: normal;
    }
}
.dianzan {
    width: 16px !important;
    height: 16px !important;
}
&.en-US,
&.pl-PL {
    .shape-title {
        width: 200px;
        text-align: left;
        padding-left: 20px;
    }
}
&.ar-AR {
    .result-wrapper {
        .show {
            text-align: right;
        }
    }
    .result-box {
        text-align: right;
        .result-wrapper3 {
            justify-content: space-between;
            .right {
                margin-left: 0;
                margin-right: 10px;
                .title {
                    margin-right: 0;
                    text-align: right;
                }
                .tips {
                    text-align: right;
                    margin-right: 0;
                }
            }
        }
        .hip-title {
            border-left: none;
            border-right: 1px solid #00e3c9;
            padding-left: auto;
            padding-right: 10px;
            text-align: right;
        }
        .hip-tips {
            text-align: right;
        }
    }
}
&.el-GR {
    .result-box .hip-tips {
        font-family: Helvetica;
    }
    .shape-title {
        width: 230px;
    }
}
</style>